import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import apiexplorer1 from "../../assets/apiexplorer1.png";
import apiexplorer2 from "../../assets/apiexplorer2.png";
import apiexplorer3 from "../../assets/apiexplorer3.png";

export default function UsingApiExplorer() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Using API Explorer</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>API Explorer provides access to all Enlil API documentation.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    API documentation may be viewed by Category, which groups data by subject matter, or as a list.<br/><br/>
                    <img alt="Navigate to the Dashboard" src={apiexplorer3} style={{objectFit: "contain", width: "200px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    The bolded header, gives an overview of the subject matter. <br/><br/>
                    <img alt="Navigate to the Dashboard" src={apiexplorer2} style={{objectFit: "contain", width: "200px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    The greyed GET/POST/PUT items details their respective APIs. Enlil only supports GET, POST, PUT and OPTIONS api types.<br/><br/>
                    <img alt="Navigate to the Dashboard" src={apiexplorer1} style={{objectFit: "contain", width: "200px"}}/>
                </li>
            </ul>
        </div>
    )
}